import { render, staticRenderFns } from "./tooltips.vue.js?vue&type=template&id=89ad34ac&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./tooltips.vue?vue&type=template&id=89ad34ac&vue3"
import script from "./tooltips.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./tooltips.vue?vue&type=script&lang=js&vue3"
export * from "./tooltips.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./tooltips.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports